import React, { useEffect, useState } from 'react'
import { Row, Col, Alert as AlertB } from 'react-bootstrap';

const VARIANTS = [

    {
        name    : "primary",
        style: {
            "color"             : "white",
            "backgroundColor"   : "#0d6efda8",
            "fontSize"          : "12px",
        }
    },

    {
        name    :   "Danger",
        style:{
            "color"             : "white",
            "backgroundColor"   : "#dc3545",
            "fontSize"          : "12px",
        }
    },

];

const load_variant = (name,set_variant)=>{

   const variant = VARIANTS.find(x=> x.name === name);

   if(variant !== null){
    set_variant(variant); return;
   }

} 

function Alert(props) {

    const [show,set_show] = useState(false);
    const [variant,set_variant] = useState(VARIANTS[0]);

    const [message,set_message] = useState("");

    useEffect(()=>{

        if(props.show !== undefined) set_show(props.show);

        if(props.variant !== undefined) {
            load_variant(props.variant,set_variant);
        }

        if(props.message !== undefined) set_message(props.message);

    },[props]);

  return (
    <>
        <Row style={{display:show ? "inline" : "none"}}>
            <Col>
                <AlertB style={variant.style} variant={variant.name} className='text-center'>{message}</AlertB>
            </Col>
        </Row>
    </>
  )
}

export default Alert